export const backendUrl = process.env.NEXT_PUBLIC_API_URL;
export const domainUrl = process.env.NEXT_PUBLIC_DOMAIN_URL || "";
export const companyName = process.env.NEXT_PUBLIC_COMPNAY;
export const expireCache: number = process.env.NEXT_PUBLIC_HTTP_CACHE_TTL ? Number(process.env.NEXT_PUBLIC_HTTP_CACHE_TTL) : 15;
export const awsS3BaseURL = process.env.NEXT_PUBLIC_AWS_FILES_URL ?? "https://pefoc-development.s3.eu-central-1.amazonaws.com/";
export const authHttpKey = process.env.NEXT_PUBLIC_AUTH_HTTP_KEY || "";
export const authHttpShuffleKey = process.env.NEXT_PUBLIC_AUTH_HTTP_SHUFFLE_KEY || "";
